import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import Tooltip from '@material-ui/core/Tooltip';

// STYLES
import { ChannelCardBoxShadow } from './styles';

const ChannelCard = ({ data, active, hover }) => {
  const [t] = useTranslation();
  const hasAddon = Boolean(data.addons?.length);
  const isNotAvailable = data.notAvailable || ('in_all_dmas' in data && !data.in_all_dmas);

  const ChannelCardWrapper = ({ children }) => {
    if (data.name) {
      return <Tooltip title={data.name}>{children}</Tooltip>;
    }

    return <>{children}</>;
  };

  ChannelCardWrapper.propTypes = {
    children: PropTypes.element.isRequired,
  };

  return (
    <ChannelCardBoxShadow className={clsx('channel-card', hover && 'channel-card--hover')}>
      {hasAddon && (
        <div className="channel-card__addons">
          {data.addons.map(addon => {
            return (
              <Tooltip key={`addon-${addon.id}`} title={addon.service_name}>
                <div className="channel-card__addons-item">
                  <img
                    src={
                      addon.addon_icon ||
                      `https://dummyimage.com/24X24.png?text=${addon.service_name}`
                    }
                    alt={addon.service_name}
                  />
                </div>
              </Tooltip>
            );
          })}
        </div>
      )}

      {isNotAvailable && (
        <Tooltip title={t('channelCard.notAvailable')}>
          <div className="channel-card__not-available">
            <div className="channel-card__not-available-item">
              <img
                src={`${process.env.REACT_APP_CLOUDFRONT_LINK}/assets/images/icons/pin.svg`}
                alt={t('channelCard.notAvailable')}
              />
            </div>
          </div>
        </Tooltip>
      )}
      <ChannelCardWrapper>
        <div
          className={clsx('channel-card__container', active && 'channel-card__container--active')}
        >
          <img
            className="channel-card__image p4"
            src={data.imageSrc}
            alt={`channel-card-${data.name}`}
          />
        </div>
      </ChannelCardWrapper>
    </ChannelCardBoxShadow>
  );
};

ChannelCard.propTypes = {
  data: PropTypes.object,
  active: PropTypes.bool,
  hover: PropTypes.bool,
};

export default React.memo(ChannelCard);
